module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"sitemove":"Sites Link","login":"로그인","guestreserv":"비회원 예약확인"},"en":{"sitemove":"Sites Link","login":"Login","guestreserv":"Non-member reservation confirmation"},"ja":{"sitemove":"Sites Link","login":"ログイン","guestreserv":"非会員予約確認"}}')
  delete Component.options._Ctor
}
